import {
  cn,
  en
} from '../assets/commonjs/language';




const state = {
  language: 'cn'
}

const getters = {
  lan(state) {
    return state.language =="cn" ? cn : en
  }
}

const mutations = {
  setlanguage(state, type) {
    state.language = type
  }

}



export default {
  namespaced: true,
  state,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/store/common.js